import { useEffect } from "react";
import { Graph } from "../graph/Graph";
import { Interval } from "../navigation/tabs/TabsTypes";
import { GraphType } from "../graph/GraphTypes";
import { timestampToDate } from "../helpers/DateHelper";
import classes from "./NoAreaStats.module.css";
import i18n from "../i18n";

interface IProps {
  startDate: number;
  endDate: number;
  serial: string;
  title: string;
}

export const NoAreaStats = ({ startDate, endDate, serial, title }: IProps) => {
  // Auto‑refresh every 15 s to keep data live
  useEffect(() => {
    const timer = setInterval(() => {
      console.log("[NoAreaStats] Refetching data every 15 seconds");
    }, 15000);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      {/* Per‑Hour view */}
      <div className={classes.StatsContainer}>
        <label className={classes.StatsLabel}>
          {i18n.t("NoAreaAlarms")} {timestampToDate(startDate)} {i18n.t("AlarmTo")} {timestampToDate(endDate)} – {title} ({i18n.t("PerHour")})
        </label>
        <div className={classes.TitleSeparator} />
        <div className={classes.GraphContainer}>
          <Graph
            startDatePeriodTimestamp={startDate}
            endDatePeriodTimestamp={endDate}
            interval={Interval.HOUR}
            graphType={GraphType.NOAREA_ALARM_EVOLUTION}
            preventUpdateAnimations
            nodePath=""
            securispot={serial}
            export
          />
        </div>
      </div>

      {/* Per‑Day view */}
      <div className={classes.StatsContainer}>
        <label className={classes.StatsLabel}>
          {i18n.t("NoAreaAlarms")} {timestampToDate(startDate)} {i18n.t("AlarmTo")} {timestampToDate(endDate)} – {title} ({i18n.t("PerDay")})
        </label>
        <div className={classes.TitleSeparator} />
        <div className={classes.GraphContainer}>
          <Graph
            startDatePeriodTimestamp={startDate}
            endDatePeriodTimestamp={endDate}
            interval={Interval.DAY}
            graphType={GraphType.NOAREA_ALARM_EVOLUTION}
            preventUpdateAnimations
            nodePath=""
            securispot={serial}
            export
          />
        </div>
      </div>

    </>
  );
};